(() => {
    let last = 0;

	// Simple little script to make sure columns don't reflow when accordions are opened.
	// @link https://stackoverflow.com/a/51062093
    $('.service-areas-accordion .accordion-item').each((i, el) => {
		const $this = $(el);
        if ($this.offset()['top'] <= last) {
            // start of new column
            $this.css({
                'column-break-before': 'always',
                'break-before': 'column'
            });
        }
        last = $this.offset()['top'];
    });
})();